<!-- eslint-disable vue/no-multiple-template-root -->
<template>
  <div id="observer-root" class="observation" :style="{backgroundColor: backgroundColor}">
    <Head>
      <Title>{{ pageData.pageTitle }}</Title>
      <Meta name="description" hid="description" :content="pageData.pageDescription" />
      <Meta name="og:image" hid="og:image" :content="OG_IMAGE" />
    </Head>
    <BlocksNewHomeHero v-bind="hero[0]" />
    <BlocksNewContentLayout :content="content" />
  </div>
</template>
<script setup>
import { DIASPORA_START_PAGE_QUERY } from '@/utils/graphql-queries'
import request from '@/api/dato/datohelper'
import { OG_IMAGE } from '@/utils/resources'

definePageMeta({
  stopDefaultSwitch: true,
  key: route => route.params.country
})
const { setLocale } = useI18n()
const { $bus, $track, $mRouter } = useNuxtApp()
const currentLocale = useLocale() || 'en'
const route = useRoute()

const backgroundColor = ref('black')

const content = ref([])

const hero = ref({})

const alternativeSlugs = ref(null)

const pageData = ref({})

const query = `query MyQuery {
      country: diasporaStartPage(locale: ${currentLocale}, filter: {slug: {eq: "${route.params.country}"}}) {
          ${DIASPORA_START_PAGE_QUERY}
      }
      default: diasporaStartPage(locale: ${currentLocale}, filter: {slug: {eq: "default"}}) {
          ${DIASPORA_START_PAGE_QUERY}
      }
    }`

const response = await request(query, 'diasporaPages' + route.params.country + currentLocale)

if (response.country) {
  pageData.value = response.country

  // Case: alterntiveSlugs exist for the country. We use the alternativeSlugs defined in the CMS.
  alternativeSlugs.value = response.country.alternativeSlugs ? response.country.alternativeSlugs[0] : null
} else {
  pageData.value = response.default
}
hero.value = pageData.value.hero
content.value = pageData.value.content

// Case: country does not have alternativeSlugs because it uses the default page from CMS. So we query the countries api to fetch the list.

if (!alternativeSlugs.value) {
  const country = await useCountries().getCountryBySlug(route.params.country)
  alternativeSlugs.value = country.alternativeSlugs
}

const handleLocaleSwitch = async (val) => {
  let country
  // if mode = 1, switch between country pages. if mode = 0, use for global page to go home.
  let mode = 0

  if (val.destinationCountry) {
    country = await useCountries().getCountry(val.destinationCountry)
    mode = 1
  }

  const countrySlug = country ? country.alternativeSlugs[val.destinationLocale] : alternativeSlugs.value[val.destinationLocale]

  setLocale(val.destinationLocale).then(() => {
    if (mode === 1) {
      window.location.href = $mRouter.getLocalRoute({ name: 'country', params: { country: countrySlug } }).href
    } else {
      window.location.href = $mRouter.getLocalRoute({ name: 'index' }).href
    }
  })
}

$bus.onDynamicRouteChangeLanguage(route.meta.key, handleLocaleSwitch)

</script>
  <style scoped>
  .observation {
    transition: background-color 0.5s ease;
    -webkit-transition: background-color 0.5es ease;
  }
  </style>
